<template>
  <div>
    <CCard>
      <CCardHeader>
        {{ $t("New Cover Year") }}
        <div class="card-header-actions">
          <CButton
            class="mz-button v2-mz-btn mr-2"
            color="primary"
            @click="createCoverYear"
            :disabled="!selected_branch || !coveryear_id"
          >
            {{ $t("Save") }}
            <em class="ml-2 mz-icon icon-save color-inherit"/>
          </CButton>
        </div>
      </CCardHeader>
      <CCardBody>
        <CForm class="d-flex flex-column gap-8">
          <div>
            <label>
              <div class="title">{{ $t("Year identification") }}</div>
            </label>
            <div class="flex items-center space-x-2 gap-4">
              <MzDatePicker
                v-model="coveryear_id"
                :config="{ format: 'YYYY', minDate: 2000 }"
                class="input-group"
                placeholder="YYYY"
              />
              <div class="mt-1">

              </div>
              <span v-if="existingYear">
                {{ $t("This cover year is already created, you can change it in the GAREAT rates section") }}
              </span>
            </div>
          </div>
          <hr/>
          <div>
            <label>
              <div class="title">{{ $t("Gareat Rates") }}</div>
            </label>
            <div class="gareat-rates">
              <CRow
                class="w-100"
                v-for="(rates_row, index) in rates_list_in_rows"
                :key="`${rates_row.length}_${index}`"
              >
                <CCol
                  v-for="rate in rates_row"
                  col="6"
                  :key="rate.label"
                >
                  <label>{{ $t(rate.label) }}:</label>
                  <div class="d-flex">
                    <CInput
                      :key="`${rate.label}_${rate.value}`"
                      class="w-90"
                      addInputClasses="mz-input text-right w-350"
                      type="number"
                      :value="rate.value"
                      :min=0
                      :max=100
                      @change="v => handleRateInput(rate.label, v)"
                    />
                    <span class="ml-1 mt-1">%</span>
                  </div>
                </CCol>
              </CRow>
            </div>
          </div>
        </CForm>
      </CCardBody>
    </CCard>
  </div>
</template>

<script>
import {CoverYearServices} from "@/services/coveryears";
import {BranchesServices} from "../../services/branches";
import {ActiveUser} from "../../services/user";
import moment from "moment";
import {getNumericalValue} from "@/utils/helpers";

export default {
  name: "NewCoverYear",
  data: function () {
    return {
      getNumericalValue,
      start_date: null,
      end_date: null,
      coveryear_id: null,
      currentTime: new Date(),
      rates: [],
      selected_branch: null,
      row_size: 2,
      disabledYears: [],
    };
  },
  async mounted() {
    this.rates = await BranchesServices.getBranchList()
    this.rates = this.rates.map((rate) => {
      return {
        label: this.$store.state.language == 'en' ? rate.EN : rate.branch,
        id_branch: rate.id_branch,
        value: 0
      }
    })
    if (this.rates.length) {
      this.selected_branch = this.rates[0].id_branch
    } else {
      alert(this.$t("No Branch data. Please create Branch instance before creating new Cover Year"), {
                action: {
                    text: this.$t('Close'),
                    icon: 'close',
                    onClick: (e, toastObject) => {
                        toastObject.goAway(0);
                    }
                }
            })
    }
    const coveryear_data = await CoverYearServices.fetchCoverYears();
    this.disabledYears = coveryear_data.map(item => item.id_coveryear)
  },
  computed: {
    rates_list_in_rows() {
      const coveryear_list_in_rows = []
      for (let i = 0; i < this.rates.length; i += this.row_size) {
        const chunk = this.rates.slice(i, i + this.row_size);
        coveryear_list_in_rows.push(chunk)
      }
      return coveryear_list_in_rows
    },
    existingYear() {
      return this.coveryear_id && this.disabledYears.includes(parseInt(this.coveryear_id));
    }
  },
  methods: {
    handleRateInput(key_str, v) {
      if(parseFloat(v) === 0) v = '0';
      if (parseFloat(v).toFixed(2) > 100) v = '100'
      if(v !== '0') v = this.getNumericalValue(parseFloat(v), 2)

      this.rates = this.rates.map(rat => ({
        ...rat,
        value: key_str === rat.label ? v : rat.value
      }))
    },
    async createCoverYear() {
      const today = new Date();
      if (!this.selected_branch || !this.coveryear_id) {
        alert(this.$t("Please fill all required data"), {
                action: {
                    text: this.$t('Close'),
                    icon: 'close',
                    onClick: (e, toastObject) => {
                        toastObject.goAway(0);
                    }
                }
            });
        return
      }

      const negative_rates_flag = this.rates.some(item => parseFloat(item.value) < 0);
      if (negative_rates_flag) {
        alert(this.$t('Inputed rates must be positive'), {
                action: {
                    text: this.$t('Close'),
                    icon: 'close',
                    onClick: (e, toastObject) => {
                        toastObject.goAway(0);
                    }
                }
            });
            return
          }

      const {res} = await CoverYearServices.createCoverYear({
        id_coveryear: this.coveryear_id,
        id_branch: this.selected_branch,
        date_start: this.start_date,
        date_end: this.end_date,
        date_creation: moment(today).format('YYYY-MM-DD HH:mm:ss'),
        user_creation: ActiveUser?.user?.email,
        rates: this.rates,
      });
      if (res.status !== 200) {
        alert(this.$t('Failed to create cover year'), {
                action: {
                    text: this.$t('Close'),
                    icon: 'close',
                    onClick: (e, toastObject) => {
                        toastObject.goAway(0);
                    }
                }
            });
      } else {
        await this.$router.push({
          name: "Cover Year",
        });
      }
    },
  },
};
</script>

<style lang="scss">
.title {
  font-size: 1.5em;
}

.w-90 {
  width: 90%;
  max-width: 350px;
}

.w-350 {
  max-width: 350px;
}

.input-group {
  max-width: 500px;
}

.arrow-buttons {
  display: none;
}
</style>
